import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { axiosPlugin, axiosInstance } from './plugins/axios'
import { createPinia } from 'pinia'

import "@/assets/hyper/vendor/mdi/css/materialdesignicons.min.css"
import "@/assets/hyper/scss/app.scss"
import "@/assets/scss/app.scss"

import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';

import { authModule } from "@/stores/auth.js";
import { useAutoLogout } from "@/stores/autoLogout.js";
import { themeModule } from "@/stores/theme.js";
import tooltip from "@/directives/tooltip.js";
import popover from "@/directives/popover.js";
import phone from "@/directives/phone.js";
import trn from "@/directives/trn.js";

const app = createApp(App)

// Directives
app.directive('tooltip', tooltip)
app.directive('popover', popover)
app.directive('phone', phone)
app.directive('trn', trn)

app.config.errorHandler = (err, vm, info) => {
  // Report only. The previous handler re-mounted the app here, which could
  // never work: `h` was not imported, mount() ignores a second argument, and
  // the app is already mounted - so every unhandled error logged a spurious
  // "App has already been mounted" warning on top of the real one.
  console.error('Unhandled error:', info, err);
}

app.config.globalProperties.$swal = Swal

const pinia = createPinia()
pinia.use(({ store }) => {
  store.$axios = axiosInstance
  store.$router = router
})

// Adds instances to set up
app.provide('swal', Swal);

app.use(pinia)
app.use(router)
app.use(axiosPlugin)

const authStore = authModule()
authStore.persistUser()

// On boot, not just after login: a refresh used to lose the timer entirely.
useAutoLogout().initialize()

// Applies the saved Hyper config to <html>; without this the data-* attributes
// the theme reads are never written.
const themeStore = themeModule()
themeStore.getLocalStorage()
themeStore.setHtmlAtributes()

app.mount('#app')